import { createContext, type ReactNode, useContext } from 'react';
import { usePhieuThuExport, useSearchFieldState } from '../hooks';

interface PhieuThuContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  searchFieldState: ReturnType<typeof useSearchFieldState>;
}

const PhieuThuContext = createContext<PhieuThuContextValue | null>(null);

export const usePhieuThuContext = () => {
  const context = useContext(PhieuThuContext);
  if (!context) {
    throw new Error('usePhieuThuContext must be used within PhieuThuProvider');
  }
  return context;
};

export const PhieuThuProvider = ({ children }: { children: ReactNode }) => {
  const { exportToExcel, canExport, isExporting } = usePhieuThuExport();
  const searchFieldState = useSearchFieldState();

  return (
    <PhieuThuContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting,
        searchFieldState
      }}
    >
      {children}
    </PhieuThuContext.Provider>
  );
};
